import { render, staticRenderFns } from "./FlatUser.vue?vue&type=template&id=fe533f8c&"
import script from "./FlatUser.vue?vue&type=script&lang=js&"
export * from "./FlatUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports